<template>
    <div>
        <ProductForm 
        :currencyEndpoint="currencyEndpoint"
        :taxEndpoint="taxEndpoint"
        :subcategoryEndpoint="subcategoryEndpoint"/>
        <ImagesForm/>
        <InventoryForm v-if="!productData.classified" />
        <AttributesForm v-if="!productData.classified" />
        <VariantForm v-if="!productData.classified" />
        <div class="columns  is-centered">
            <div class="column is-half has-text-centered">
                <b-button
                class="is-medium"
                type="is-primary"
                rounded
                :loading="isLoading"
                @click="saveProduct(createEndpoint)">
                <b-icon size="is-small" icon="save"></b-icon>
                    Guardar producto
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import ProductForm from "./components/ProductForm.vue";
import InventoryForm from "./components/InventoryForm.vue";
import AttributesForm from "./components/AttributesForm.vue";
import ImagesForm from "./components/ImagesForm.vue"
import VariantForm from "./components/VariantForm"

import {mapActions, mapGetters} from "vuex"

export default {
    name:"AddProduct",
    props:{
        createEndpoint:{
            type:String,
            default:""
        },
        currencyEndpoint:{
            type:String,
            default:""
        },
        taxEndpoint:{
            type:String,
            default:""
        },
        subcategoryEndpoint:{
            type:String,
            default:""
        },
        filtersUrl:{
            type:String,
            default:""
        }
    },
    components: {
        ProductForm,
        InventoryForm,
        AttributesForm,
        ImagesForm,
        VariantForm
    },
    methods:{
        ...mapActions(['saveProduct', 'fetchFilters'])
    },
    computed:{
        ...mapGetters(['productData', 'isLoading'])
    },
    created(){
        this.fetchFilters(this.filtersUrl)
    }
}
</script>
<style lang="scss">
@import "./../../../scss/main.scss";
</style>